var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAllInteract = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 17",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.582 5.949a5.254 5.254 0 0 1 3.085 4.801V13c0 .828-.664 1.5-1.482 1.5H8.741c-1.935 0-3.582-1.252-4.192-3m7.033-5.551C11.114 3.97 9.356 2.5 7.259 2.5h-.74c-2.864 0-5.186 2.35-5.186 5.25V10c0 .828.664 1.5 1.482 1.5h1.734m7.033-5.551c.08.337.122.689.122 1.051 0 2.485-1.99 4.5-4.445 4.5H4.55m2.118-4.333a1.333 1.333 0 1 0-1.334-1.334",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.333 9.167a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0Z",
  fill: "currentColor"
})));
export default SvgAllInteract;